/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_End_Other_ConfirmInputs */

const en_us2_offline_end_other_confirm = /** @type {(inputs: Offline_End_Other_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End and sync`)
};

const pt_br2_offline_end_other_confirm = /** @type {(inputs: Offline_End_Other_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar e sincronizar`)
};

const es_419_offline_end_other_confirm = /** @type {(inputs: Offline_End_Other_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar y sincronizar`)
};

const pt_pt2_offline_end_other_confirm = /** @type {(inputs: Offline_End_Other_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar e sincronizar`)
};

const fr_fr2_offline_end_other_confirm = /** @type {(inputs: Offline_End_Other_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer et synchroniser`)
};

const de_de2_offline_end_other_confirm = /** @type {(inputs: Offline_End_Other_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beenden und synchronisieren`)
};

const it_it2_offline_end_other_confirm = /** @type {(inputs: Offline_End_Other_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi e sincronizza`)
};

/**
* | output |
* | --- |
* | "End and sync" |
*
* @param {Offline_End_Other_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_end_other_confirm = /** @type {((inputs?: Offline_End_Other_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_End_Other_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_end_other_confirm(inputs)
	if (locale === "es-419") return es_419_offline_end_other_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_end_other_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_end_other_confirm(inputs)
	if (locale === "de-DE") return de_de2_offline_end_other_confirm(inputs)
	if (locale === "it-IT") return it_it2_offline_end_other_confirm(inputs)
	return en_us2_offline_end_other_confirm(inputs)
});
export { offline_end_other_confirm as "offline.end_other_confirm" }